import * as Yup from 'yup';
import { requiredField } from './utils/messages';

export const saleReportValidationSchema = Yup.object().shape({
  initial_date: Yup.date().typeError(requiredField).required(requiredField),
  final_date: Yup.date().typeError(requiredField).required(requiredField),
  operation_id: Yup.number().typeError(requiredField).required(requiredField),
});
